export interface CreatedSalesOrder {
  id: string;
  salesOrderNumber: number;
  customerKey: string;
  customerName: string;
  currencyCode: string;
  noOfLines: number;
  productKey: string;
  productDescription: string;
  productTypeDescription: string;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  value: number;
  deliveryDate: Date;
}
